<template>
  <transition name="fade" mode="out-in">
    <component
        :is="currentLayout"
        :key="currentLayout.name"
        :header-options="headerOptions"/>
  </transition>
</template>

<script>
import AppLayout from '@/layouts/AppLayout';
import DashboardLayout from '@/layouts/DashboardLayout';
import EmptyLayout from '@/layouts/EmptyLayout';
import ErrorLayout from '@/layouts/ErrorLayout';
import JobRequestLayout from '@/layouts/JobRequestLayout';
import ProDeskReportingLayout from '@/layouts/ProDeskReportingLayout';

import NewDashboardLayout from './NewDashboardLayout';

const LAYOUTS = {
  AppLayout,
  DashboardLayout,
  ErrorLayout,
  JobRequestLayout,
  ProDeskReportingLayout,
  NewDashboardLayout,
};

export default {
  name: 'layout-broker',
  computed: {
    headerOptions () {
      // start with the current route and look upwards for header options
      const route = this.$route.matched
        .slice()
        .reverse()
        .find(r => r.meta.headerOptions !== undefined);

      return route && route.meta.headerOptions;
    },
    currentLayout () {
      // start with the current route and look upwards for a layout
      const route = this.$route.matched.slice().reverse().find(r => r.meta.layout !== undefined);
      const isDev = process.env.NODE_ENV !== 'production';

      if (route) {
        const layout = LAYOUTS[route.meta.layout];

        if (layout) {
          return layout;
        }

        if (isDev) {
          // eslint-disable-next-line no-console
          console.error(`The layout "${route.meta.layout}" was not found - using empty layout.`);
        }

        return EmptyLayout;
      }

      if (isDev) {
        // eslint-disable-next-line no-console
        console.warn('No layout defined - using empty layout.');
      }

      return EmptyLayout;
    },
  },
};
</script>
